export default {
  nome: {
    value: '',
    required: true,
    state: null
  },
  origemId: {
    value: null,
    options: [],
    required: true
  },
  boardId: {
    value: null,
    required: true,
    options: []
  },
  boardColumnId: {
    value: null,
    required: true,
    options: []
  },
  urlRedirecionamento: {
    value: null,
    options: [],
    required: false
  },
  urlConversao: {
    value: null,
    options: [],
    required: false,
    disabled: true
  },
  urlRdStation: {
    value: null,
    options: [],
    required: false,
    disabled: true
  },
  ativo: {
    value: null,
    options: [],
    required: false
  }
}



// WEBPACK FOOTER //
// ./src/views/private/campaign/components/socialmedia/components/add/campanharedesocialadd-form.js